module.exports = require('./input');

module.exports.PublicKey = require('./publickey');
module.exports.PublicKeyHash = require('./publickeyhash');
module.exports.MultiSig = require('./multisig');
module.exports.MultiSigScriptHash = require('./multisigscripthash');
module.exports.Taproot = require('./taproot');
